<template>
    <div> 
        <v-card color=""
            tile="" 
            flat="" :height="height"
            @dragover.prevent="isDragging = true"
            @dragleave.prevent="isDragging = false"
            @drop.prevent="ON_EXCEL_DROP" 
            >  
            <!-- //NO SELECTED ITEMS -->
            <v-layout column
                v-if="!MBS.actions.SIZE(SELECTED_ITEMS) || isDragging" 
                fill-height align-center justify-center
                class="upload-container" 
                :class="{ 'dragging': isDragging }"
            >

            <v-icon size="50" color="green" v-if="isDragging">mdi-file-upload</v-icon> 
                <span v-if="isDragging">
                    <div class="font-weight-bold not-f5 grey--text--darken-2 mt-2 mb-1">Upload Excel File</div> 
                </span>
                <v-chip large color="b1" v-else >
                    <v-icon class="mx-5" color="grey">mdi-tag</v-icon>

                    <span class="grey--text mr-2">
                        No Selected Item 
                    </span>
                    <div class=" mr-5">Drag & Drop Excel</div>
                </v-chip>
            </v-layout>  
    
            <!-- //TABLE VIEW -->
            <div v-else-if="true"> 
                <v-simple-table  class="  mr-2 ml-4" dense :height="height" fixed-header >
                    <!-- <template v-slot:default>
                    </template> -->
                    <thead>  
                        <!-- //-----------[RECEIVING HEADERS] -->
                        <tr v-if="verify_stock" class="font-weight-bold "> 
                            <th class="ma-0 pa-0 " style="width:'5px'"> 
                                <v-switch :inset="false"    style="height: ''; margin: 5px;"
                                    v-model="item_multiple_select"
                                    label=""   hide-details
                                    class="ml-1"
                                ></v-switch> 
                            </th>
                            <th class=" text-left b  ">
                                ITEM NAME
                            </th> 
                            <th class="text-center  b" v-if="outlet_code">
                                EXPECTED    
                            </th>
                            <th class="text-center  ">
                                VERIFIED
                            </th>
                            <th class="text-center " v-if="outlet_code"> 
                                DISCREPANCY 
                            </th> 
                            <th class="text-center  b  "> 
                            </th>  
                        </tr> 
                        <!-- //-----------[RECEIVING HEADERS] -->
                        <tr v-else-if="action_type == DATA.ITEMS.STOCK_RECEIVES.values || action_type == DATA.ITEMS.STOCK_REQUISITIONS.values" class="font-weight-bold "> 
                            <th class="ma-0 pa-0 " style="width:'5px'"> 
                                <v-switch :inset="false"    style="height: ''; margin: 5px;"
                                    v-model="item_multiple_select"
                                    label=""   hide-details
                                    class="ml-1"
                                ></v-switch> 
                            </th>
                            <th class=" text-left b  ">
                                ITEM NAME
                            </th> 
                            <th class="text-center  b" v-if="outlet_code">
                                CURRENT    
                            </th>
                            <th class="text-center  ">
                                RECEIVE
                            </th>
                            <th class="text-center " v-if="outlet_code"> 
                                AFTER 
                            </th> 
                            <th class="text-center  b  "> 
                            </th>  
                        </tr>
                        <!-- //-----------[RECEIVING HEADERS] -->
                        <tr v-else class="font-weight-bold "> 
                            <th class="ma-0 pa-0 " style="width:'5px'"> 
                                <v-switch :inset="false"    style="height: ''; margin: 5px;"
                                    v-model="item_multiple_select"
                                    label=""   hide-details
                                    class="ml-1"
                                ></v-switch> 
                            </th>
                            <th class=" text-left b  ">
                                ITEM NAME
                            </th> 
                            <th class="text-center  b" v-if="outlet_code">
                                CURRENT    
                            </th>
                            <th class="text-center  ">
                                TRANSFER
                            </th>
                            <th class="text-center " v-if="outlet_code"> 
                                AFTER 
                            </th> 
                            <th class="text-center  b  "> 
                            </th>  
                        </tr> 
                    </thead>
                    <tbody> 
                        <tr class="pointer "  
                            v-for="(item,index) in SELECTED_ITEMS"
                            :key="item.key" 
                            :class="item.checked?'checked':''"
                            @click="ON_EDIT_SELECTED_ITEM(item,index)"
                            @mousedown="startLongClick"
                            @mouseup="endLongClick"
                            > 
                            <template v-if="verify_stock"> 
                                <td class=" text-center with-divider-lr  ma-0 pa-0 table-background1" style="width:40px;"> 
                                    <v-simple-checkbox @click.stop="" class="ma-0 pa-0"
                                        v-if="item_multiple_select" icon 
                                        color="primary" 
                                        :value="item.checked" 
                                        @input="INPUT_UPDATE($event, item,true)" 
                                        />  
                                    <span v-else icon >
                                        <v-icon v-if="item.expand">expand_more</v-icon>
                                        <v-icon v-else>chevron_right</v-icon>
                                    </span>  
                                </td>               
                                <td class=" with-divider ">
                                    {{ item.name }}
                                </td>
                                <td class=" text-center with-divider " v-if="outlet_code"> 
                                    {{ toNumber(item.quantity) }}
                                </td>  
                                <td class=" text-center pa-0  with-divider  " style="width: 130px;"> 
                                    <input   
                                        autofocus 
                                        @click.stop="" 
                                        @input="INPUT_VERIFY($event, item,)" 
                                        ref="ref_payment_cash"
                                        :value="item.verified_quantity"    
                                        class="mbs-excel-input"   
                                    />
                                </td> 
                                <td class=" text-center pa-0 with-divider " style="width:130px; position: relative;" v-if="outlet_code">
                                    <span v-if="item.verified_quantity">{{  toNumber(item.verified_quantity) - toNumber(item.quantity)  }}</span>
                                    
                                </td>
                                <td class=" text-center with-divider  px-2">
                                    <v-btn  icon class="ma-0 pa-0" @click.stop="VERIFY_ITEM(item,index)">
                                        <v-icon v-if="!toNumber(item.verified_quantity)">mdi-checkbox-blank-outline</v-icon> 
                                        <v-icon v-else-if="toNumber(item.quantity) - toNumber(item.verified_quantity) == 0">mdi-checkbox-marked-outline</v-icon>
                                        <v-icon v-else-if="toNumber(item.quantity) - toNumber(item.verified_quantity) < 0">{{mdiCheckboxMarkedCirclePlusOutline}}</v-icon>
                                        <v-icon v-else-if="toNumber(item.quantity) - toNumber(item.verified_quantity) > 0">{{mdiCheckboxMarkedCircleMinusOutline}}</v-icon>
                                    </v-btn>
                                </td>
                            </template>
                            <template v-else> 
                                <td class=" text-center with-divider-lr  ma-0 pa-0 table-background1" style="width:40px;"> 
                                    <v-simple-checkbox @click.stop="" class="ma-0 pa-0"
                                        v-if="item_multiple_select" icon 
                                        color="primary" 
                                        :value="item.checked" 
                                        @input="INPUT_UPDATE($event, item,true)" 
                                        />  
                                    <span v-else icon >
                                        <v-icon v-if="item.expand">expand_more</v-icon>
                                        <v-icon v-else>chevron_right</v-icon>
                                    </span>  
                                </td>
                                <td class=" with-divider ">
                                    {{ item.name }}
                                </td>
                                <td class=" text-center with-divider " v-if="outlet_code"> 
                                    {{ toNumber(item[outlet_code+'_number_quantity']) }}
                                </td>  
                                <td class=" text-center pa-0  with-divider  " style="width: 130px;"> 
                                    <input  :disabled="edit_selected_items"
                                        autofocus 
                                        @click.stop="" 
                                        @input="INPUT_UPDATE2($event, item,)" 
                                        ref="ref_payment_cash"
                                        :value="item.quantity"    
                                        class="mbs-excel-input"   
                                    />
                                </td> 
                                <td class=" text-center pa-0 with-divider " style="width:130px; position: relative;" v-if="outlet_code">
                                    <input  :disabled="edit_selected_items"
                                        autofocus 
                                        @click.stop="" 
                                        @input="INPUT_UPDATE($event, item,)" 
                                        ref="ref_payment_cash"   
                                        :value="item.new_quantity"   
                                        class="mbs-excel-input center pl-9"   
                                    />  
                                </td>
                                <td class=" text-center with-divider  px-2">
                                    <v-btn :disabled="edit_selected_items" icon class="ma-0 pa-0" @click.stop="CONFIRM_REMOVE_ITEM(item,index)"><v-icon>delete</v-icon></v-btn>
                                </td>
                            </template>
                        </tr>
                        <v-divider />
                    </tbody>
                </v-simple-table> 
            </div> 
        </v-card>

        <!-- //DIALOGS -->
        <div>
            <!-- EDIT ITEM DIALOG -->
            <v-dialog
                v-model="dialog_edit_selected_item"
                :scrollable="true"  
                :persistent="false" :overlay="true"
                max-width="800px"
                transition="dialog-transition" >
                <v-card height="100%" rounded="sm" color="b1" v-if="current_selected_item">
                    <v-card-title class="primary pa-2" >
                        <v-list-item dark>
                            <v-list-item-action>
                                <v-icon>mdi-tag</v-icon> 
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>{{ current_selected_item.name }}</v-list-item-title> 
                                <v-list-item-subtitle>{{ current_selected_item.category_name }}</v-list-item-subtitle>  
                            </v-list-item-content> 
                            <!-- <v-list-item-action>
                                <v-layout align-center >
                                    <div class="mr-1 not-f3 mt-2">MWK</div>
                                    
                                    <span  class="not-f8 font-weight-bold"> 
                                        {{MBS.actions.money(CALCULATE_PRICE(current_selected_item))}} 
                                    </span>
                                </v-layout>
                            </v-list-item-action> -->
                        </v-list-item>
                    </v-card-title>
                    <div outlined class="mbs-borders mx-2 mt-2 mb-2 pa-2" :style="'--size:1px; --color:grey; --conner:3px'">
                        <form @submit.prevent="UPDATE_SELECTED_ITEM({
                            item:current_selected_item,
                            self_contain:true
                        })">
                            <v-card-text class="b1">
                                <v-row>
                                    <v-col cols="12" sm="12" class="py-0"> 
                                        <div>Cost Price</div> 
                                        <v-text-field dense color="primary" readonly   
                                            filled outlined v-mask="currencyMask"
                                            :value="current_selected_item.cost_price" 
                                            append-icon="mdi-pencil"
                                            outline
                                        ></v-text-field>  
                                    </v-col>
                                    
                                    <v-col cols="12" sm="6" class="py-0"> 
                                        <div>{{ToOutlet?ToOutlet.name+"":' '}} Current (QTY)</div> 
                                        <v-text-field dense color="primary" readonly   
                                            filled outlined v-mask="currencyMask"
                                            :value="current_selected_item[outlet_code+'_number_quantity']" 
                                            outline
                                        ></v-text-field>  
                                    </v-col>

                                    <v-col cols="12" sm="6" class="py-0 " >
                                        <div>Receive (QTY)</div>
                                            <v-text-field dense autofocus
                                                filled outlined 
                                                v-model="current_selected_item.quantity"
                                                @focus="FOCUS_INPUT({value:'current_selected_item_quantity',
                                                ref:'ref_current_selected_item_quantity'})"
                                                outline
                                            ></v-text-field> 
                                    </v-col> 
                                </v-row> 
                            </v-card-text> 
                             
                            <v-layout row wrap class="ma-0  mt-4">
                                <v-flex sm12 md6> 
                                    <v-card height="100%" hover class="mr-2 "> 
                                        <v-layout justify-center align-center fill-height class="mbs-border primary lighten-5  pa-2" :style="'--size:1px; --color:grey; --conner:3px'"> 
                                            <mbs-keyboard 
                                                :type="'number'"
                                                :row="'5'"
                                                :key_function="true"
                                                />
                                        </v-layout>
                                    </v-card>
                                </v-flex>
                                <v-flex sm12 md6>
                                    <v-card height="100%" hover>
                                        <v-layout column  class="ma-0" fill-height justify-center align-center>  
                                            <v-spacer></v-spacer>
                                            <v-btn @click="CONFIRM_REMOVE_ITEM(current_selected_item)"
                                                class="my-2 font-weight-bold" 
                                                color="primary" :height="vs.smAndDown?'60':'70'" width="96%">
                                                <v-layout justify-center align-center> 
                                                    <v-icon class="mr-2">delete</v-icon>
                                                    <div class="not-f5 mt-1">Remove Item</div> 
                                                </v-layout>
                                            </v-btn>  
                                            <v-btn type="submit"
                                                class="my-2 font-weight-bold"   
                                                color="secondary" :height="vs.smAndDown?'60':'70'" width="96%">
                                                <v-layout justify-center align-center> 
                                                    <v-icon class="mr-2">mdi-upload</v-icon>
                                                    <div class="not-f5 mt-1">Update Item</div> 
                                                </v-layout>
                                            </v-btn>   
                                        </v-layout> 
                                    </v-card>
                                </v-flex> 
                            </v-layout>   
                        </form>
                    </div> 
                </v-card> 
            </v-dialog>  

            <!-- EXCEL_FILE_SELECTED -->
            <mbs-excel-selector
                :dialog_show="true"
                :show_input="false"
                :show_output="true"
                @onDataSelected="EXCEL_DATA_SELECTED" 
                @onFileSelected="EXCEL_FILE_SELECTED" 
                @onNoFileSelected="NO_EXCEL_FILE_SELECTED" 
                @onLoadingFile="LOADING_FILE" 
                @onError="ON_FILE_ERROR" 
                /> 
        </div>
    </div>
</template> 
<script> 

    import DATA from "../../../plugins/DATA";
    import {mapState} from "vuex" 
    import DB from "../../../plugins/DB";
    import { toNumber } from "../../../plugins/formatNumber"; 
    import { mdiCheckboxMarkedCirclePlusOutline } from '@mdi/js';
    import { mdiCheckboxMarkedCircleMinusOutline } from '@mdi/js';
    const PAGE_NAME = "RECEIVE_SELECT_ITEMS"

    export default {
        props:['height','selected_items','color','verify_stock', 'edit_selected_items',
        'outlet_code','to_outlet_code','from_outlet_code','from_supplier_code','to_supplier_code',
        'items','action_type' ],
        data(){
            return{
                show:false,   
                DATA:DATA,
                item_multiple_select:false,   
                dialog_edit_selected_item:false,   
                current_selected_item:null,   
                input:{},   
                isDragging:false,   
                focused_field:null,   
                longClickTimer: null,
                longClickDetected: false,

                
                selectedRows: [],
                lastSelectedRow: -1,
                editingCell: null,
                INPUT_VERIFYING: false,
                INPUT_TIMER: 0,
                mdiCheckboxMarkedCirclePlusOutline:mdiCheckboxMarkedCirclePlusOutline,
                mdiCheckboxMarkedCircleMinusOutline:mdiCheckboxMarkedCircleMinusOutline,
            }
        },
        created(){ 
            try {
                this.MBS.events.$on('ON_QR_SCAN', this.ON_QR_SCAN);   
                this.MBS.events.$on('MBS_KEYBOARD', this.MBS_KEYBOARD); 
                this.MBS.events.$on('ADD_STOCK_INVENTORY_SELECTED_ITEMS', this.ADD_STOCK_INVENTORY_SELECTED_ITEMS); 
                this.MBS.events.$on('INITIALIZE_RECEIVE_SELECTED_ITEMS', this.INITIALIZE_RECEIVE_SELECTED_ITEMS); 
                this.MBS.events.$on('CLEAR_RECEIVE_SELECTED_ITEMS', this.CLEAR_RECEIVE_SELECTED_ITEMS); 
                this.MBS.events.$on('VERIFY_INVENTORY', this.VERIFY_INVENTORY); 
                this.INITIALIZE_RECEIVE_SELECTED_ITEMS()
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:PAGE_NAME, 
                }) 
            }
        },
        mounted(){  
            this.OUTPUT() 
        },
        computed:{
            vs(){
                let vs = this.$vuetify.breakpoint 
                return vs
            }, 
            vs_width(){
                let vs = this.vs
                if(!vs){return null}
                return vs.width
            },
            vsh(){
                return this.vs.height
            },
            ...mapState({
                loading:state=>state.load.loading,
                processes:state=>state.load.processes,
                responses:state=>state.load.responses,
            }),
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
                SELECTED_COMPANY: state=> state.items['SELECTED_COMPANY'],
                K_CONNECTOR: state=> state.items['K_CONNECTOR'],
            }),
            ...mapState({
                CompanySettings: state=> state.items[(DATA.ITEMS.COMPANY_SETTINGS.values).toUpperCase()], 
                CompanyQuickActions: state=> state.items[(DATA.ITEMS.COMPANY_QUICK_ACTIONS.values).toUpperCase()], 
                Items: state=> state.items[(DATA.ITEMS.ITEMS.values).toUpperCase()],
                JoinedItems: state=> state.join[(DATA.ITEMS.ITEMS.values).toUpperCase()], 
                ItemCategories: state=> state.items[(DATA.ITEMS.ITEM_CATEGORIES.values).toUpperCase()],
                
                DaysShifts: state=> state.items[(DATA.ITEMS.DAYS_SHIFTS.values).toUpperCase()],
                JoinedDaysShifts: state=> state.join[(DATA.ITEMS.DAYS_SHIFTS.values).toUpperCase()], 
                LocalSaleOrders: state=> state.items[(DATA.ITEMS.LOCAL_SALE_ORDERS.values).toUpperCase()],
                JoinedLocalSaleOrders: state=> state.join[(DATA.ITEMS.LOCAL_SALE_ORDERS.values).toUpperCase()],
                
               
                Outlets: state=> state.items[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()],
                JoinedOutlets: state=> state.join[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()], 
                
                LocalSelectedSalesItems: state=> state.locals[(DATA.ITEMS.LOCAL_SELECTED_STOCK_ADJUSTMENTS.values).toUpperCase()],
                JoinedLocalSelectedSalesItems: state=> state.join[(DATA.ITEMS.LOCAL_SELECTED_STOCK_ADJUSTMENTS.values).toUpperCase()], 
            }), 

            //data
            ItemsData(){
                const Items = this.Items
                const JoinedItems = this.JoinedItems
                const data = JoinedItems?JoinedItems:Items
                return data 
            },
            LocalSelectedSalesItemsData(){
                const Items = this.LocalSelectedSalesItems
                const JoinedItems = this.JoinedLocalSelectedSalesItems
                const data = JoinedItems?JoinedItems:Items
                return data 
            },
            ReversedLocalSelectedSalesItemsData(){   
                const items = this.LocalSelectedSalesItemsData 
                if(!items) {return null}
                let list = [...items]
                list.sort(this.MBS.actions.dynamicSort("selecting_list_key",true))
                return list.reverse()
            }, 
            CheckedItems(){
                const SELECTED_ITEMS = this.SELECTED_ITEMS
                if(!SELECTED_ITEMS){return null}
                let filtered = SELECTED_ITEMS.filter(item=>item.checked)
                return filtered
            },
            FromOutlet(){
                const code = this.from_outlet_code
                let outlet = this.$store.getters.getStockOutletByCode(code)
                return outlet
            },
            selected_outlet_code(){
                
            },
            ToOutlet(){
                const code = this.outlet_code
                let outlet = this.$store.getters.getStockOutletByCode(code)
                return outlet
            },

            SELECTED_ITEMS(){
                const settings = this.CompanySettings
                const selling_list_descend = settings?settings.selling_list_descend:null
                const items = this.LocalSelectedSalesItemsData 
                const reversed = this.ReversedLocalSelectedSalesItemsData   
                return selling_list_descend?reversed:items
            },
            LocalCashup(){   
                let localCashup = this.MBS.actions.LocalCashup 
                return localCashup
            }, 
            //pricing
            CalculateItemsPrice(){
                return (items)=>{ 
                    try {   
                        let total_price = 0 
                        if (!items) {return 0}
                        items.forEach(item => {
                            let sold_price = this.toNumber(item.sold_price)
                            let quantity = this.toNumber(item.quantity)
                            total_price = total_price + (quantity*(sold_price))
                        });  
                        // return total_price
                        return total_price.toFixed(2) 
                        
                    } catch (error) {
                        this.MBS.actions.error({
                            error:error,
                            from:'TotalPrice',
                            page:PAGE_NAME, 
                        }) 
                        return 0
                    }  
                }
            },
            TotalPrice(){
                try { 
                    // if (this.SELECTED_CARD_OPTION=='load_money') { 
                    //    return this.toNumber(this.pay_order?this.pay_order.card_load_amount:0)
                    // } else {
                    // }
                    let items = this.SELECTED_ITEMS
                    let total_price = 0 
                    if (!items) {return 0}
                    items.forEach(item => {
                        let sold_price = this.toNumber(item.sold_price)
                        let quantity = this.toNumber(item.quantity)
                        total_price = total_price + (quantity*(sold_price))
                    });  
                    // return total_price
                    return total_price.toFixed(2) 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'TotalPrice',
                        page:PAGE_NAME, 
                    }) 
                    return 0
                }  
            }, 
            TotalDiscountedPrice(){
                try {  
                    let discount = this.toNumber(this.TotalDiscount)
                    let CalculatedVAT = this.CalculatedVAT
                    let total_vat = this.toNumber(CalculatedVAT?CalculatedVAT.total_vat:0)
                    let total_price = this.toNumber(this.TotalPrice)
 
                    const settings = this.CompanySettings
                    const items_are_vat_exclusive = settings?settings.items_are_vat_exclusive:null
                    const calculate_vat = settings?settings.calculate_vat:null

                    if (items_are_vat_exclusive && calculate_vat) {
                        total_price = total_price+total_vat
                    }
                     
                    return total_price-discount
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'TotalPrice',
                        page:PAGE_NAME, 
                    }) 
                    return 0
                }  
            }, 
            CalculatedVAT(){
                try { 
                    const settings = this.CompanySettings
                    const items_are_vat_exclusive = settings?settings.items_are_vat_exclusive:null
                    const calculate_vat = settings?settings.calculate_vat:null
                    const SELECTED_ITEMS = this.SELECTED_ITEMS
                    if(!calculate_vat){return null}
                    let vat = {
                        taxable_a:0,
                        vat_a:0,
                        taxable_b:0,
                        vat_b:0,
                        taxable_c:0,
                        vat_c:0,
                        total_vat:0,
                        vat_exclusive:items_are_vat_exclusive
                    }
                    if(SELECTED_ITEMS){ 
                        SELECTED_ITEMS.forEach(item => {
                            let tax_group_code = item.tax_group_code?item.tax_group_code:"A"
                            let sold_price = this.toNumber(item.sold_price)*this.toNumber(item.quantity)
                            
                            let item_vat = 0
                            
                            if (tax_group_code=="A") {
                                vat.taxable_a = vat.taxable_a + sold_price
                                if (items_are_vat_exclusive) {
                                    item_vat = sold_price*17.5/100
                                } else {
                                    let not_vat_price = sold_price / (1+(17.5/100))
                                    item_vat = sold_price-not_vat_price 
                                }
                                vat.vat_a = vat.vat_a+item_vat
                            }if (tax_group_code=="B") {
                                vat.taxable_b = vat.taxable_b + sold_price
                            }if (tax_group_code=="E") {
                                vat.taxable_c = vat.taxable_c + sold_price
                                
                            }
                            
                        }); 
                        vat.total_vat = vat.vat_a + vat.vat_b+vat.vat_c
                        if (!items_are_vat_exclusive) {
                            vat.taxable_a = vat.taxable_a - vat.vat_a
                            vat.taxable_b = vat.taxable_b - vat.vat_b
                            vat.taxable_c = vat.taxable_c - vat.vat_c
                        }
                    } 
                    return vat
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'TotalPayments',
                        page:PAGE_NAME, 
                    }) 
                    return 0
                }  
            }, 
            PriceExcludeVAT(){
                try { 
                    const settings = this.CompanySettings
                    const items_are_vat_exclusive = settings?settings.items_are_vat_exclusive:null
                    const calculate_vat = settings?settings.calculate_vat:null
                    return (price,tax_group_code)=>{
                        price = this.toNumber(price) 
                        if (calculate_vat && !items_are_vat_exclusive) {
                            if (tax_group_code=="B"||tax_group_code=="E") {
                                return price
                            }
                            return price / (1+(17.5/100))
                        }
                        return price

                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'PriceExcludeVAT',
                        page:PAGE_NAME, 
                    }) 
                    return 0
                }  
            }, 
            
              
        },
        methods:{ 
            handleKeyDown(event) {
                // if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                //     event.preventDefault();
                // }
            },
            isEditing(rowIndex, columnIndex) {
            return this.editingCell && this.editingCell.row === rowIndex && this.editingCell.column === columnIndex;
            },
            startEditing(rowIndex, columnIndex) {
            this.editingCell = { row: rowIndex, column: columnIndex };
            this.$nextTick(() => this.$refs.editField.focus());
            },
            stopEditing(rowIndex, columnIndex) {
            this.editingCell = null;
            },
            selectRow(index) {
                if (this.lastSelectedRow !== -1 && this.$root.shiftKey) {
                    const start = Math.min(this.lastSelectedRow, index);
                    const end = Math.max(this.lastSelectedRow, index);
                    this.selectedRows = [];

                    for (let i = start; i <= end; i++) {
                    this.selectedRows.push(i);
                    }
                } else if (this.selectedRows.includes(index)) {
                    this.selectedRows.splice(this.selectedRows.indexOf(index), 1);
                } else {
                    this.selectedRows.push(index);
                } 
                this.lastSelectedRow = index;
            },


            startLongClick() {
                this.longClickTimer = setTimeout(() => {
                    this.longClickDetected = true;
                    this.item_multiple_select = !this.item_multiple_select;
                    console.log('Long click detected');
                }, 1000); 
            },
            endLongClick() {
                clearTimeout(this.longClickTimer);
                setTimeout(() => { 
                    this.longClickDetected = false;
                }, 10);
            },

            CALCULATE_PRICE(item){
                try { 
                    if (!item) {return 0}
                    const sold_price = this.toNumber(item.sold_price)
                    const quantity = this.toNumber(item.quantity)
                    return quantity*(sold_price)
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CALCULATE_PRICE',
                        page:PAGE_NAME, 
                    }) 
                }
                
            }, 
            ON_EDIT_SELECTED_ITEM(item){
                try { 
                    // if ( this.item_multiple_select) {
                    //     let index = this.SELECTED_ITEMS.findIndex(it=>it.selecting_list_key = item.selecting_list_key)
                    //     this.$set(this.SELECTED_ITEMS, index, { check: item.check?false:true});
                    //     return
                    // }
                    if (!this.longClickDetected) {
                        this.current_selected_item = null 
                        setTimeout(() => {
                            this.dialog_edit_selected_item = true
                            this.current_selected_item = {...item}   
                        }, 30);
                    }
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_EDIT_SELECTED_ITEM',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            CONFIRM_REMOVE_ITEM(selected_item,index){
                try { 
                    this.dialog_edit_selected_item = false
                    // this.$emit("confirm_remove_item",selected_item,index)
                    this.REMOVE_ITEM(selected_item)
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CONFIRM_REMOVE_ITEM',
                        page:PAGE_NAME, 
                    }) 
                }
                
            },
            REMOVE_ITEM(data){
                try { 
                    // this.$emit("remove_item",data)
                    let company = this.SELECTED_COMPANY
                    let company_key = company?company.company_key:null
                    console.log(company,'c........');
                    console.log(data,'delete item,..........');

                    DB.deleteItems({
                        name:DATA.ITEMS.LOCAL_SELECTED_STOCK_ADJUSTMENTS.values,
                        key:data.key,
                        update_locals:true,
                        // company_key:company_key, 
                    }).then(res=>{
                        console.log(res,'res........');
                    }).catch(error=>{
                        console.log(error,'error...........');
                    })
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'REMOVE_ITEM',
                        page:PAGE_NAME, 
                    }) 
                }
                
            }, 
            FOCUS_INPUT(field){
                this.focused_field = field 
            },
            VERIFY_AFTER_INPUT(quantity,new_quantity,item){
                if (this.INPUT_TIMER) {
                    clearTimeout(this.INPUT_TIMER)
                    this.INPUT_TIMER=0
                    console.log(this.INPUT_TIMER,'-----this.INPUT_TIMER-----');
                }
                if (quantity<0) { 
                    console.log(item,'----------');
                    
                    this.INPUT_TIMER = setTimeout(() => {
                        this.UPDATE_SELECTED_ITEM({
                            item:item,
                            new_quantity:new_quantity, 
                            quantity:0
                        })
                        this.MBS.actions.dialog({
                            show:true,
                            icon:'error',
                            title:"ERROR",
                            text:"Stock after can not be less than the current stock.",
                            btnYes:"OKAY" 
                        })  
                        this.INPUT_VERIFYING = false
                    }, 3000); 
                }  

            },
            INPUT_UPDATE(event,item,check_item){
                try { 
                    const action_type = this.action_type
                    const action_receive = action_type == DATA.ITEMS.STOCK_RECEIVES.values || action_type == DATA.ITEMS.STOCK_REQUISITIONS.values
                    const target = event?event.target:null
                    let value = target?target.value:null 
                    if (value=="") {
                        return
                    }
                    value = this.toNumber(value)
                    const number_quantity =  this.toNumber(item[this.outlet_code+'_number_quantity'])  
                    if(check_item){
                        item = {
                            ...item,
                            checked:event?true:false
                        }
                        value = this.toNumber(item.quantity)
                    }   
                    const quantity = action_receive?value-number_quantity:number_quantity-value
                    this.VERIFY_AFTER_INPUT(quantity,number_quantity,item) 
                    this.UPDATE_SELECTED_ITEM({
                        item:item,
                        new_quantity:value, 
                        quantity:quantity
                    }) 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'INPUT_UPDATE',
                        page:PAGE_NAME, 
                    }) 
                }
            },
            INPUT_UPDATE2(event,item,check_item){
                try { 
                    const action_type = this.action_type
                    const action_receive = action_type == DATA.ITEMS.STOCK_RECEIVES.values || action_type == DATA.ITEMS.STOCK_REQUISITIONS.values
                    let target = event?event.target:null
                    let value = target?target.value:null 
                    if (value=="") {
                        return
                    }
                    value = this.toNumber(value)
                    let number_quantity =  this.toNumber(item[this.outlet_code+'_number_quantity']) 
                    if(check_item){
                        item = {
                            ...item,
                            checked:event?true:false
                        }
                        value = this.toNumber(item.quantity)
                    } 
                    const new_quantity = action_receive?value+number_quantity:number_quantity-value
                    this.UPDATE_SELECTED_ITEM({
                        item:item,
                        quantity:value,
                        new_quantity:new_quantity, 
                    }) 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'INPUT_UPDATE2',
                        page:PAGE_NAME, 
                    }) 
                }
            },
            INPUT_VERIFY(event,item,check_item){
                try { 
                    const action_type = this.action_type
                    const action_receive = action_type == DATA.ITEMS.STOCK_RECEIVES.values || action_type == DATA.ITEMS.STOCK_REQUISITIONS.values
                    let target = event?event.target:null
                    let value = target?target.value:null 
                    if (value=="") {
                        return
                    }
                    value = this.toNumber(value)  
                    console.log(value,'----------');
                    
                    this.UPDATE_SELECTED_ITEM({
                        item:item,
                        verified_quantity:value, 
                        verify:true
                    }) 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'INPUT_VERIFY',
                        page:PAGE_NAME, 
                    }) 
                }
            },
            VERIFY_ITEM(item,index){
                try {  
                    const quantity = this.toNumber(item?.quantity)
                    const verified_quantity = this.toNumber(item?.verified_quantity)
                    const discrepancy = verified_quantity - quantity
                    let verify_number = 0
                    if (discrepancy != 0) {
                        verify_number = quantity
                    }

                    this.UPDATE_SELECTED_ITEM({
                        item:item,
                        verified_quantity:verify_number, 
                        verify:true
                    }) 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'INPUT_VERIFY',
                        page:PAGE_NAME, 
                    }) 
                }
            },
             
            async INITIALIZE_RECEIVE_SELECTED_ITEMS(payload){
                try {
                    const action_type = this.action_type
                    const action_receive = action_type == DATA.ITEMS.STOCK_RECEIVES.values || action_type == DATA.ITEMS.STOCK_REQUISITIONS.values
                    const p_to_outlet_code = payload?.outlet_code
                    const outlet_code = p_to_outlet_code?p_to_outlet_code:this.outlet_code 
                    
                    if (outlet_code) {
                        const res_selected_items = await DB.getItems({
                            name:DATA.ITEMS.LOCAL_SELECTED_STOCK_ADJUSTMENTS.values,
                        })
                        const selected_items = res_selected_items?.data
                        let update_items = []
                        selected_items?.forEach(selected_item => {
                            const quantity = this.toNumber(selected_item.quantity)
                            const outlet_quantity = this.toNumber(selected_item[outlet_code+'_number_quantity'])
                            const new_quantity = action_receive?outlet_quantity+quantity:outlet_quantity-quantity
                            update_items.push({
                                ...selected_item,
                                new_quantity:new_quantity,
                            })
                            
                        });

                        let res = await DB.addItems({
                            data:update_items,
                            name:DATA.ITEMS.LOCAL_SELECTED_STOCK_ADJUSTMENTS.values, 
                            update_locals:true,   
                        }) 
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'INITIALIZE_RECEIVE_SELECTED_ITEMS',
                        page:PAGE_NAME, 
                    }) 
                }
            },
            CLEAR_RECEIVE_SELECTED_ITEMS(payload){
                try {   
                    const show_response = payload?.show_response
                    DB.deleteItems({
                        name:DATA.ITEMS.LOCAL_SELECTED_STOCK_ADJUSTMENTS.values, 
                        update_locals:true, 
                    }).then(res=>{
                        console.log(res,'res........');
                        this.MBS.actions.progressDialog()
                        if (show_response) {
                            let mbs_text = this.MBS.text.item_action_success("Selected Items","Clearing")
                            this.MBS.actions.dialog({
                                show:true,
                                title:mbs_text.title,
                                text:mbs_text.text,
                                btnYes:mbs_text.btnYes,
                                btnNo:mbs_text.btnNo, 
                            })     
                        }
                    }).catch(error=>{
                        console.log(error,'error...........');
                        this.MBS.actions.progressDialog()
                        if (show_response) {
                            let mbs_text = this.MBS.text.item_action_fail("Selected Items","Clearing")
                            this.MBS.actions.dialog({
                                show:true,
                                title:mbs_text.title,
                                text:mbs_text.text,
                                btnYes:mbs_text.btnYes,
                                btnNo:mbs_text.btnNo, 
                            }) 
                        }
                    })
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CONFIRM_CLEAR_SELECTED_ITEMS',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            VERIFY_INVENTORY(payload){
                try  {
                    const selected_items = this.SELECTED_ITEMS
                    const verify = payload?.verify
                    if (selected_items) {
                        const updating_items = []
                        selected_items.forEach(item => {
                            const quantity = this.toNumber(item.quantity)
                            updating_items.push({
                                ...item,
                                verified_quantity:verify?quantity:0
                            })
                        });
                        console.log(updating_items,"updating_items......");
                        
                        this.UPDATE_SELECTED_ITEM({
                            items:updating_items,
                            only_update:true
                        })
                    }

                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'VERIFY_INVENTORY',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            async UPDATE_SELECTED_ITEM(payload){
                try {
                    this.dialog_edit_selected_item = false
                    const item = payload?payload.item:null
                    const items = payload?payload.items:null
                    const quantity = payload?payload.quantity:null
                    const new_quantity = payload?payload.new_quantity:null 
                    const self_contain = payload?payload.self_contain:null
                    const verified_quantity = payload?payload.verified_quantity:null
                    const verify = payload?.verify 
                    const only_update = payload?.only_update 
                    let update_detail = null

                    if (only_update) {
                        update_detail = items?items:item 
                    } else {
                        if (self_contain) {
                            let number_quantity =  this.toNumber(item[this.outlet_code+'_number_quantity']) 
                            quantity = this.toNumber(item.quantity)
                            new_quantity = quantity + number_quantity 
                        }
    
                        update_detail = {
                            ...item,
                            quantity:this.toNumber(quantity),
                            new_quantity:this.toNumber(new_quantity) 
                        }
                        if (verify) {
                            update_detail = {
                                ...item,
                                verified_quantity:this.toNumber(verified_quantity), 
                            }
                        } 
                    }

                    let res = await DB.addItems({
                        data:update_detail,
                        name:DATA.ITEMS.LOCAL_SELECTED_STOCK_ADJUSTMENTS.values, 
                        update_locals:true,   
                    })
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'UPDATE_SELECTED_ITEM',
                        page:PAGE_NAME, 
                    }) 
                }
            },
            ANALYZE_AND_SELECT_ITEM(item_key, item_code){
                try { 
                    let company_key = this.SELECTED_COMPANY?this.SELECTED_COMPANY.key:null
                    const settings = this.CompanySettings 
                    const activate_stock_level = settings?settings.activate_stock_level:null
                    const duplicate_selling_item = settings?settings.duplicate_selling_item:null 
                    
                    let quantity = null
                    let retail_price = null
                    let wholesale_price = null
                    let scales = this.Scales  
                    
                    const items = this.ItemsData
                    const outlet_code = this.outlet_code
                    const moment = this.MBS.date.moment
                    const selecting_list_key = moment?moment().valueOf():null

                    
                    if (!outlet_code) {
                        this.MBS.actions.dialog({
                            show:true,
                            fixed:true,
                            title:"SELECT OUTLET",
                            text:"You must select outlet first",
                            btnYes:"Okay",
                            action:{
                                code:PAGE_NAME+"=SELECT-OUTLET"
                            }
                        })
                        return
                    }
                    if (items) {
                        let item_selected = items.find(item=>{
                            return  item_key?item.key == item_key:item.code == item_code
                        })

                        

                        if (!item_selected) {
                            this.MBS.actions.dialog()
                            setTimeout(() => {
                                this.MBS.actions.dialog({
                                    show:true,
                                    title:'ITEM NOT FOUND',
                                    text:"Item ("+item_code+") not found. Make sure Items are loaded and you have refreshed.",
                                    btnYes:"OKAY",
                                    btnNo:"CREATE AS NEW ITEM",
                                    action:{
                                        code:PAGE_NAME+'=CREATE_AS_NEW_ITEM',
                                        item_code:item_code,
                                    }
                                }) 
                            }, 500);
                            return 
                        } 
             

                        /// if array
                        let newItem = {
                            ...item_selected, 
                            quantity:0,
                        }
 
 
                        return {
                            item_key:item_key,
                            item_code:item_code,
                            duplicate_selling_item:duplicate_selling_item,
                            company_key:company_key,
                            selected_item:newItem,
                        }
                    }
                     
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ANALYZE_AND_SELECT_ITEM',
                        page:PAGE_NAME, 
                    }) 
                }
            },
            ADD_STOCK_INVENTORY_SELECTED_ITEMS(payload){ 
                try {
                    const action_type = this.action_type
                    const action_receive = action_type == DATA.ITEMS.STOCK_RECEIVES.values || action_type == DATA.ITEMS.STOCK_REQUISITIONS.values
                    let items = this.ItemsData
                    let already_selected_items = this.SELECTED_ITEMS

                    let company_settings = payload?payload.company_settings:null
                    let outlet_code = this.outlet_code
                    let activate_stock_level = company_settings?company_settings.activate_stock_level:null

                    let item_key = payload?payload.item_key:null
                    let item_code = payload?payload.item_code:null
                    let selected_item = payload?payload.selected_item:null
                    let selected_items = payload?payload.selected_items:null
                    if (selected_items) {
                        let loading_items = []
                        selected_items.forEach(item => {
                            const selected_item = items?.find(it=>it.key == item.key || it.key == item.item_key)
                            if (selected_item) {
                                loading_items.push({
                                    ...selected_item,
                                    ...item,
                                    _key:selected_item.key,
                                    _code:selected_item.code,
                                })
                            }
                        });
                        DB.addItems({
                            data:loading_items,
                            name:DATA.ITEMS.LOCAL_SELECTED_STOCK_ADJUSTMENTS.values,
                            update_locals:true,
                             
                        })
                        this.INITIALIZE_RECEIVE_SELECTED_ITEMS()
                        console.log(loading_items,'loading_items+++++++++++++');
                        console.log(items,'items+++++++++++++');
                        console.log(selected_items,'selected_items+++++++++++++');
                        
                        return
                    }
                    if (!selected_item) {
                        let analyzed = this.ANALYZE_AND_SELECT_ITEM(item_key,item_code)
                        selected_item = analyzed?analyzed.selected_item:null
                    }
                    if (selected_item) {
                        const moment = this.MBS.date.moment
                        const selecting_list_key = moment?moment().valueOf():null
                        const quantity = this.toNumber(selected_item.quantity)
                        const outlet_quantity = this.toNumber(selected_item[outlet_code+'_number_quantity'])
                        const new_quantity = action_receive?outlet_quantity+quantity:outlet_quantity-quantity
                        let save_item = {
                            ...selected_item,
                            _key:selected_item.key,
                            _code:selected_item.code,
                            key:selecting_list_key,
                            selecting_list_key:selecting_list_key,
                            quantity:quantity,
                            new_quantity:new_quantity,
                        } 
    
                         
                        let already_item = already_selected_items?already_selected_items.find(it=>it._key == selected_item.key):false
                        if (already_item) {
                            const outlet_quantity = this.toNumber(selected_item[outlet_code+'_number_quantity'])
                            const quantity = this.toNumber(already_item.quantity)+1
                            const new_quantity = action_receive?outlet_quantity+quantity:outlet_quantity-quantity
                            save_item = {
                                ...already_item,
                                new_quantity:new_quantity, 
                                quantity:quantity
                            }  
                        } 

                        if (activate_stock_level) {
                            const quantity = this.toNumber(save_item.quantity) 
                            let res = this.MBS.actions.CHECK_ITEM_STOCK_SETTINGS({
                                outlet_code:outlet_code,
                                item:selected_item,
                                quantity:quantity, 
                                notify:true,
                            }) 
                            let allow_sell = res?res.allow_sell:null
                            if (!allow_sell) {
                                return
                            }
    
                            
                        }
                        
                        DB.addItems({
                            data:save_item,
                            name:DATA.ITEMS.LOCAL_SELECTED_STOCK_ADJUSTMENTS.values,
                            update_locals:true,
                             
                        })
                        
                    }else{ 
                        console.log(payload,'pay................');
                    }
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ADD_STOCK_INVENTORY_SELECTED_ITEMS',
                        page:PAGE_NAME, 
                    }) 
                }
            },
            CREATE_SALE_ORDER(){
                try {

                    let selectedCompany = this.SELECTED_COMPANY 
                    let company_key = selectedCompany?selectedCompany.key:null
                    let localCashup = this.LocalCashup 
                    let cashup_key = localCashup?localCashup.key:null
                    let day_shift_key = localCashup?localCashup.day_shift_key:null
                 
                    
                    let TotalPrice = this.TotalPrice
                    let TotalDiscount = this.TotalDiscount
                    let TotalDiscountedPrice = this.TotalDiscountedPrice
                    let us = this.us
                    let uid = us?us.uid:null
                    let SELECTED_ITEMS = this.SELECTED_ITEMS
                    let items_size = this.MBS.actions.SIZE(SELECTED_ITEMS)
                    let moment = this.MBS.date.moment
                    let key =  moment?moment().valueOf():null
                    let CalculatedVAT = this.CalculatedVAT

                    if (items_size<1) { 
                    }
                    let order_details = {
                        sold:true,
                        created_uid:uid,
                        key:key,
                        cashup_key:cashup_key,
                        day_shift_key:day_shift_key,
                        company_key:company_key, 
                        paid_amount:TotalDiscountedPrice,
                        total_price:TotalPrice,
                        total_discount:TotalDiscount,
                        local_created_at:key, 
                        order_type:DATA.ITEMS.SALE_ORDERS.value, 
                    }
                   
                    if (CalculatedVAT) {
                        order_details.calculated_vat = CalculatedVAT
                    }
                    let order_items = []

                    if (SELECTED_ITEMS) {
                        SELECTED_ITEMS.forEach(element => {
                            let average_cost_price = this.toNumber(element.average_cost_price)
                            let cost_price = this.toNumber(element.cost_price)
                            let sold_cost_price = average_cost_price?average_cost_price:cost_price
                            order_items.push({ 
                                sold_price:this.toNumber(element.sold_price),
                                sold_cost_price:sold_cost_price,
                                quantity:this.toNumber(element.quantity), 
                                order_key:key,
                                item_key:element._key?element._key:element.key,
                                key:element.key,
                                _key:element._key?element._key:element.key,
                            })
                        }); 
                    }
                    order_details.items = order_items

                   

                    // CHECK STOCK SETTINGS
                    // if (activate_stock_level) {
                    //     let stock_settings = this.CHECK_ITEMS_STOCK_SETTINGS({
                    //         items:SELECTED_ITEMS,
                    //         outlet_code:outlet_code,
                    //         notify:true
                    //     })
                    //     let stop_selling = stock_settings?stock_settings.stop_selling:null
                    //     if (stop_selling) {
                    //         return
                    //     }   
                    // }

                    return order_details
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CREATE_SALE_ORDER',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 

            //
            CHECK_ITEMS_STOCK_SETTINGS(payload){
                try { 
                    let response = {
                        stop_selling:false, 
                        ordering_remind:false, 
                        stock_settings:null,
                        stop_sell_items:null,
                        ordering_remind_items:null,
                        payload:payload
                    }  


                    let items = payload?payload.items:null  
                    let outlet_code = payload?payload.outlet_code:null   
                    let notify = payload?payload.notify:null   
                    if (!items) { 
                        return response
                    }

                    let stock_settings = []
                    let stop_sell_items = []
                    let ordering_remind_items = []
                    items.forEach(item => {
                        let stock_setting = this.CHECK_ITEM_STOCK_SETTINGS({
                            outlet_code:outlet_code,
                            item:item,
                            quantity:item.quantity, 
                        }) 
                        stock_settings.push(stock_setting)
                        if (stock_setting) {
                            if (!stock_setting.allow_sell) {
                               stop_sell_items.push({
                                    ...stock_setting,
                                    name:item.name
                                }) 
                               response.stop_selling = true
                            }
                            if (stock_setting.ordering_remind) {
                                ordering_remind_items.push({
                                    ...stock_setting,
                                    name:item.name
                                }) 
                                response.ordering_remind = true
                            }
                        }
                    });

                    if (notify) {
                        let stop_sell_size = this.MBS.actions.SIZE(stop_sell_items)
                        let ordering_remind_size = this.MBS.actions.SIZE(ordering_remind_items)
                        let stop_sell_names = ''
                        let ordering_remind_names = ''
                        stop_sell_items.forEach(item => {
                            stop_sell_names = stop_sell_names+"\n \n Item: "+item.name+"\n Quantity: "+item.quantity+"\n Stop selling level: "+item.stop_selling_level
                        });
                        ordering_remind_items.forEach(item => {
                            ordering_remind_names = ordering_remind_names+"\n \n Item: "+item.name+"\n Quantity: "+item.quantity+"\n Ordering level: "+item.ordering_remind_level
                        });

                        if (stop_sell_size&&ordering_remind_size) {
                            this.MBS.actions.dialog({
                                show:true,
                                title:"OUT OF STOCK",
                                text:"Some of the selected item(s) are out of stock. \n\n OUT OF STOCK ITEM(S): "+stop_sell_names
                                    +" \n\n ORDERING REMIND ITEM(S): "+ordering_remind_names    
                                    +".",
                                btnYes:"OKAY"
                            })
                        }else if (stop_sell_size) {
                            this.MBS.actions.dialog({
                                show:true,
                                title:"OUT OF STOCK",
                                text:"Some of the selected item(s) are out of stock. \n\n OUT OF STOCK ITEM(S): "+stop_sell_names  
                                    +".",
                                btnYes:"OKAY"
                            })
                        }else if (ordering_remind_size) {
                            this.MBS.actions.dialog({
                                show:true,
                                title:"LOW ON STOCK LEVEL",
                                text:"Some of the selected item(s) are below order remind level. \n\n ORDERING REMIND ITEM(S): "+ordering_remind_names    
                                    +".",
                                btnYes:"OKAY"
                            })
                        }  
                    } 
                    return {
                        ...response, 
                        allow_sell:!response.stop_selling,
                        stock_settings:stock_settings,
                        stop_sell_items:stop_sell_items,
                        ordering_remind_items:ordering_remind_items,
                    }
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CHECK_ITEMS_STOCK_SETTINGS',
                        page:PAGE_NAME, 
                    }) 
                }
                
            }, 
            CHECK_ITEM_STOCK_SETTINGS(payload){
                try { 
                    let response = {
                        allow_sell:false,
                        ordering_remind:false,
                        quantity:null,
                        stop_selling_level:null,
                        ordering_remind_level:null,
                        active_settings:null,
                        payload:payload
                    }   
                    let item_selected = payload?payload.item:null 
                    let item_selected_name = item_selected?item_selected.name:null 
                    let item_kits = item_selected?item_selected.item_kits:null 
                    let outlet_code = payload?payload.outlet_code:null  
                    let quantity = this.toNumber(payload?payload.quantity:null)
                    let notify = payload?payload.notify:null  
                    quantity = quantity?quantity:1
                    if (!item_selected) { 
                        return response
                    }
                    //
                    let sold_item = this.getSoldItem(item_selected.key)
                    let sold_quantity = this.toNumber(sold_item?sold_item.sold_quantity:null) 
                    let settings = this.CompanySettings
                    let stock_settings = settings?settings.stock_settings:null
                    let outlets_settings = stock_settings?stock_settings.outlets:null
                    let outlet_stock_settings = outlets_settings?outlets_settings[outlet_code]:null

                    let item_stock_settings = item_selected?item_selected.stock_settings:null 
                    let active_settings = item_stock_settings?item_stock_settings:outlet_stock_settings?outlet_stock_settings:stock_settings

                    response.active_settings = active_settings  

                    if (active_settings && item_selected) {
                        let stop_selling_level = this.toNumber(active_settings.stop_selling_level)
                        let ordering_remind_level = this.toNumber(active_settings.ordering_remind_level)
                        let item_quantity = this.toNumber(item_selected['number_quantity'])
                        if (outlet_code) {
                            item_quantity = this.toNumber(item_selected[outlet_code+'_number_quantity'])
                        }
                        item_quantity = item_quantity-sold_quantity
                        response.sold_quantity = sold_quantity
                        response.quantity = item_quantity
                        response.stop_selling_level = stop_selling_level
                        response.ordering_remind_level = ordering_remind_level
                        
                        if ((item_quantity-quantity) < stop_selling_level) {
                            response.allow_sell = false
                            if (notify && !item_kits) {
                                this.MBS.actions.dialog({
                                    show:true,
                                    title:"OUT OF STOCK",
                                    text:"NAME: "+item_selected_name 
                                        +"\n ITEM QUANTITY: "+item_quantity
                                        +"\n STOP SELLING LEVEL: "+stop_selling_level
                                        +"\n \n   The selected item is below selling level.",
                                    btnYes:"OKAY"
                                })  
                            }
                        }else if ((item_quantity-quantity) < ordering_remind_level) {
                            response.allow_sell = true
                            response.ordering_remind = true
                            if (notify && !item_kits) {
                                this.MBS.actions.dialog({
                                    show:true,
                                    title:"LOW ON STOCK LEVEL",
                                    text:"NAME: "+item_selected_name 
                                        +"\n ITEM QUANTITY: "+item_quantity
                                        +"\n ORDER REMIND LEVEL: "+ordering_remind_level
                                        +"\n \n   The selected item is below ordering level.", 
                                    btnYes:"OKAY"
                                }) 
                            }
                        }else{
                            response.allow_sell = true
                        }  

                        if (item_kits) {
                            // console.log(item_selected,'item_selected....');
                            response.allow_sell = true
                        }
                    }
                    if (!active_settings) {
                        response.allow_sell = true
                    }
                    return response
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CHECK_ITEM_STOCK_SETTINGS',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            
            
            //------------EXCEL
            ON_EXCEL_DROP(e){
                try { 
                    this.isDragging = false
                    this.MBS.events.$emit("ON_EXCEL_DROP",e)
                     
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_EXCEL_DROP',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
             LOADING_FILE(file){
                try {
                    this.excel_loading = true 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'LOADING_FILE',
                        page:PAGE_NAME, 
                    })
                } 
            },
            ON_FILE_ERROR(error){
                try {
                    this.excel_loading = false 

                    console.log(error);

                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'LOADING_FILE',
                        page:PAGE_NAME, 
                    })
                } 
            },
            EXCEL_DATA_SELECTED(payload){
                try {
                    console.log(payload,'payload EXCEL_DATA_SELECTED+++++');
                    
                } catch (error) {
                    this.excel_loading = false
                    this.MBS.actions.error({
                        error:error,
                        from:'EXCEL_FILE_SELECTED',
                        page:PAGE_NAME, 
                    })
                } 
            },
            EXCEL_FILE_SELECTED(file,file_details,res){
                try {
                    this.excel_loading = true
                    this.loadingValue = 50
                    setTimeout(() => {
                        this.loadingValue = 80
                        setTimeout(async() => { 
                            this.loadingValue = 90 
                            this.WB = file
                            this.WB_SHEETS = file?file.SheetNames:null
                            this.WB_PROPS = file?file.Props:null
                            this.WB_FILE_DETAILS = file_details
                            this.JSON_SHEETS = res?res.data:null 
                            let sheets = this.JSON_SHEETS
                            console.log(sheets,'sheets.......');
                            let itemsJS = null
                            if (sheets) {
                                for (const element of sheets) {
                                    if (element.name == DATA.ITEMS.ITEMS.values ) {
                                        let res = await this.MBS.actions.CREATE_ARRAY_DATA({
                                            data:element.json,
                                            headers:this.HEADER_ITEMS,
                                            attach_items:this.AllInventoriesItems,
                                            attach_value:'code',
                                            // attach_value:'key',
                                            add_number:false,
                                            add_created_date:false,
                                            add_uid:false,
                                        })  
                                        console.log(res,'res.....');
                                        itemsJS = res?res.only_attached_data:null
                                    } 
                                } 
                                this.excel_loading = false
                            }   
                            this.loadingValue = 100
                            this.excel_loading = false
                            console.log(itemsJS,'itemsJS........'); 
                            this.selected_excel_items = itemsJS  
                        }, 500);
                    }, 1000);
                } catch (error) {
                    this.excel_loading = false
                    this.MBS.actions.error({
                        error:error,
                        from:'EXCEL_FILE_SELECTED',
                        page:PAGE_NAME, 
                    })
                } 
            },
            NO_EXCEL_FILE_SELECTED(file){
                try {
                    this.excel_loading = false 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'NO_EXCEL_FILE_SELECTED',
                        page:PAGE_NAME, 
                    })
                } 
            },  

            //---------------[MAIN FUNCTIONS]------------   
            ON_QR_SCAN(code){
                try {
                    if (code) {  
                        
                        let size = this.MBS.actions.SIZE(code)
                        if (size<3) { 
                        }else{  
                             
                        }
                    }
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_QR_SCAN',
                        page:PAGE_NAME, 
                    })  
                } 
            },
            MBS_KEYBOARD(key){ 
                let focused_field = this.focused_field
                const field_value = focused_field?focused_field.value:null

                const ref_inputs = this.$refs
                if (key ) {
                    let value = key.value 
                    if (field_value) { 
                        if (field_value == "current_selected_item_quantity") {
                            if (value=="BACK_SPACE") {
                                this.current_selected_item.quantity = (""+this.current_selected_item.quantity).slice(0,-1)
                            } else {
                                this.current_selected_item.quantity =this.current_selected_item.quantity+""+value 
                            }
                        } else{
                            if(!this.input){this.input={}}
                            if (value=="BACK_SPACE") {
                                this.input[field_value] =(this.input[field_value]?this.input[field_value]+'':'').slice(0,-1)
                            }else{
                                this.input[field_value] =(this.input[field_value]?this.input[field_value]:'')+value
                                console.log((this.input[field_value]?this.input[field_value]:'')+value,'****......');
                            }
                            setTimeout(() => {
                                this.input = {...this.input}
                            }, 1);

                            console.log(this.input,'input......');
                            console.log(value,'value......');
                        }
                        
                    }
                }
            },
            OUTPUT(){ 
                try {
                    let selected_items = this.SELECTED_ITEMS
                    let sale_order = this.CREATE_SALE_ORDER()
                    let checked_items = this.CheckedItems 
                    let selected_total_sold_price = 0
                    let checked_total_sold_price = 0
                    let item_size = 0

                    //calculate selected
                    if (selected_items) {
                        for (const item of selected_items) {
                            let sold_price = this.toNumber(item.sold_price)
                            let quantity = this.toNumber(item.quantity)
                            selected_total_sold_price = selected_total_sold_price+((sold_price)*quantity)
                            item_size++
                        } 
                    }
                    
                    //calculate checked
                    if (checked_items) {
                        for (const item of checked_items) {
                            let sold_price = this.toNumber(item.sold_price)
                            let quantity = this.toNumber(item.quantity)
                            checked_total_sold_price = checked_total_sold_price+((sold_price)*quantity)
                             
                        } 
                    }
                    this.$emit("input",{
                        selected_items:selected_items,
                        selected_total_sold_price:selected_total_sold_price,
                        selected_total_sold_price_:this.MBS.actions.money(selected_total_sold_price),
                        checked_items:checked_items,
                        checked_total_sold_price_:this.MBS.actions.money(checked_total_sold_price),
                        item_size:item_size,
                        sale_order:sale_order,
                    }) 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'OUTPUT',
                        page:PAGE_NAME, 
                    }) 
                }
            },
             

        },
        beforeDestroy(){
            try {
                this.MBS.events.$off('ON_QR_SCAN', this.ON_QR_SCAN);  
                this.MBS.events.$off('MBS_KEYBOARD', this.MBS_KEYBOARD);    
                this.MBS.events.$off('ADD_STOCK_INVENTORY_SELECTED_ITEMS', this.ADD_STOCK_INVENTORY_SELECTED_ITEMS);    
                this.MBS.events.$off('INITIALIZE_RECEIVE_SELECTED_ITEMS', this.INITIALIZE_RECEIVE_SELECTED_ITEMS);    
                this.MBS.events.$off('CLEAR_RECEIVE_SELECTED_ITEMS', this.CLEAR_RECEIVE_SELECTED_ITEMS);    
                this.MBS.events.$off('VERIFY_INVENTORY', this.VERIFY_INVENTORY);    
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'beforeDestroy',
                    page:PAGE_NAME, 
                })
            }
        },
        watch:{ 
            item_multiple_select(value){
                this.$emit("item_multiple_select",value?true:false)
                this.$emit("checked_items",this.CheckedItems) 
            },
            CheckedItems(value){
                this.$emit("checked_items",value)
                this.OUTPUT()
            },
            SELECTED_ITEMS(value){
                this.$emit("selected_items",value)
                this.OUTPUT()
            },
            to_outlet_code(code){
                this.INITIALIZE_RECEIVE_SELECTED_ITEMS(code)
            },
            outlet_code(code){
                this.INITIALIZE_RECEIVE_SELECTED_ITEMS(code)
            }
        } 

    }
</script>
<style>
    .selected {
        background-color: #a8dadc;
    }
    .checked {
        background-color: #dadada;
    }
    
</style> 